import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DataTableRow = styled.tr`
    border-top:1px solid #DDD;
`;

const DataTableDataCell = styled.td`
    word-wrap:break-word;
    border-top:none !important;
    padding: 10px 0 10px 10px;
`

const DataTableTitleCell = styled(DataTableDataCell)`
    font-weight: bold;
`
const DataTableCell = ({ 
    cellTitle, 
    cellValue }
) => (
<DataTableRow>
    <DataTableTitleCell>
        {cellTitle}
    </DataTableTitleCell>
    <DataTableDataCell>
        {cellValue}
    </DataTableDataCell>
</DataTableRow>
);


DataTableCell.propTypes={
    cellTitle: PropTypes.string,
    cellValue: PropTypes.string,
}

export default DataTableCell;


// WEBPACK FOOTER //
// ./src/components/searchResults/components/searchResultsModalContent/components/dataTableCell.js